// extracted by mini-css-extract-plugin
module.exports = {"root":"verification-code-fields_root__LhO_b"};